import { render } from "./PrenatalPanelInput.vue?vue&type=template&id=2cf01ca4&scoped=true"
import script from "./PrenatalPanelInput.vue?vue&type=script&lang=js"
export * from "./PrenatalPanelInput.vue?vue&type=script&lang=js"

import "./PrenatalPanelInput.vue?vue&type=style&index=0&id=2cf01ca4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf01ca4"]])

export default __exports__